import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import termsAndConditions from '~/constants/termsAndConditions.json';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

export default function TermsAndConditionsModal() {
  const { t, i18n } = useTranslation('app');
  const dispatch = useAppDispatch();
  const locale = i18n.language.startsWith('ar') ? 'ar' : 'en';
  const content = termsAndConditions[locale];

  return (
    <Modal
      modalKey="termsAndConditionsModal"
      title={content.title}
      Footer={
        <div className="w-full">
          <Button
            size="medium"
            variant="secondary"
            className="w-full"
            onClick={() => {
              dispatch(closeModal('termsAndConditionsModal'));
            }}
          >
            {t('done')}
          </Button>
        </div>
      }
      scrolled
    >
      <div className="flex flex-col gap-2x">
        <ol className="flex list-disc flex-col gap-0.5x ps-2x ">
          {content.terms.map((term, index) => (
            <li
              key={`terms-and-conditions-${index}`}
              className="text-caption-1"
            >
              {term}
            </li>
          ))}
        </ol>
      </div>
    </Modal>
  );
}
